/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {CompositeFeaturePart} from './CompositeFeaturePart';
import {TemplateFeatureValueStates} from './TemplateFeatureValueStates';
import {Validator} from './Validator';

export interface TemplateFeature {
  id?: number;
  header: string;
  templateId?: number;
  groupId?: number;
  groupHeader?: string;
  featureId: number;
  featureTypeId: number;
  featureGroupId: number;
  unitId?: number;
  validatorId?: number;
  validator?: Validator;
  unitHeader?: string;
  featureTypeCode: string;
  featureTypeHeader: string;
  keyFeature?: boolean;
  multiple?: boolean;
  required?: boolean;
  isFilter?: boolean;
  isHidden?: boolean;
  isKeyChild?: boolean;
  isInteger?: boolean;
  sort?: number;
  units?: [];
  featureValues?: number[];
  featureValuesState?: TemplateFeatureValueStates;
  /** PIM2-580: значение по умолчанию характеристики (locale-neutral raw; кодировка как feature_value.value). */
  defaultValue?: string;
  comment?: string;
  uid?: string;
  isNewFeature?: boolean;

  unitGroupId?: number;
  defaultUnitId?: number;
  dependentUnitIds?: number[];
  fromMasterCard?: boolean;

  /** Части составного значения — только для характеристик типа COMPOSITE. */
  compositeParts?: CompositeFeaturePart[];
}
